import moment from 'moment';

export const handleRecoveryActionValidation = (
    {
        carrier,
        fromLocationName,
        from,
        toLocationName,
        to,
        impactedRunIds,
        arrivalDate,
        unloadingDate,
        collectionDate,
        dueDate,
    },
    isEmaSmaManifest = false
) => {
    const errors = {};

    if (!carrier) {
        errors.carrier = 'Carrier is required.';
    }
    if (fromLocationName === '') {
        errors.fromLocationName = 'From is required.';
    }
    if (from === '') {
        errors.from = 'From is required.';
    }
    if (toLocationName === '') {
        errors.toLocationName = 'To is required.';
    }
    if (to === '') {
        errors.to = 'To is required.';
    }
    if (fromLocationName && toLocationName && impactedRunIds && impactedRunIds.length === 0) {
        errors.impactedRunIds = 'You must select at least one run.';
    }
    if (!isEmaSmaManifest && from && to && impactedRunIds && impactedRunIds.length === 0) {
        errors.impactedRunIds = 'You must select at least one run.';
    }
    if (!arrivalDate) {
        errors.arrivalDate = 'Arrival date is required.';
    }
	if (arrivalDate && moment(arrivalDate).isBefore(moment())) {
        errors.arrivalDate = 'Arrival date cannot be in the past.';
    }
    if (!dueDate) {
        errors.dueDate = 'Due date is required.';
    }
    if (dueDate && moment(dueDate).isBefore(moment())) {
        errors.dueDate = 'Due date cannot be in the past.';
    }
    if (arrivalDate && unloadingDate && unloadingDate.isBefore(arrivalDate)) {
        errors.unloadingDate = 'Unloading cannot occur before arrival.';
    }
    if (arrivalDate && collectionDate && collectionDate.isAfter(arrivalDate)) {
        errors.collectionDate = 'Collection cannot occur after arrival.';
    }

    return errors;
};
